import {Component, EventEmitter, input, OnInit, Output, output} from '@angular/core';
import {UIComponentsModule} from '@ui-app/app.module';
import {ISiteDto} from '@employee-models/data.models';
import {LOCATION_FILTER_CONFIG} from '@employee-pages/badge-request-page/user-rules';
import {CountryEnum, KeyValue} from '@shared-models/common.models';
import {UsersService} from '../../../../../core/services/data-access/users.service';
import {BaseFieldComponent} from '@employee-pages/shared/components/fields-for-forms/base-field.component';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'employee-access-required',
    standalone: true,
    imports: [
        UIComponentsModule,
        NgMultiSelectDropDownModule,
        CommonModule,
        FormsModule
    ],
    templateUrl: './access-required.component.html',
    styleUrl: './access-required.component.less'
})
export class AccessRequiredComponent extends BaseFieldComponent implements OnInit {
    controlKey = input('accessRequiredIds');
    placeholderText = input('Search by office locations');
    disabled = input(false);
    //@Output() accessRequiredChange = new EventEmitter<string>();
    @Output() accessRequiredChange = new EventEmitter<number[]>(); // Emit number array
    availableLocations: ISiteDto[];
    selectedAccessRequired: ISiteDto[] = [];
    
    dropdownSettings = {
        singleSelection: false,
        idField: 'siteId',
        textField: 'siteName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 3,
        allowSearchFilter: true
    };
    
    protected readonly locationFilterConfig = LOCATION_FILTER_CONFIG;

    constructor(
        private usersService: UsersService) {
        super();
    }

    ngOnInit(): void {
        this.usersService.getVisitorSites(CountryEnum.USI)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(locations => {
                this.availableLocations = locations;
                super.ngOnInit();
            });
    }

    // onSelectionChange(value: { siteName: string }): void {
    //     const location = this.availableLocations.find(item => item.siteName === value.siteName);
    //     this.selectedValue = value.siteName;
    //     this.parentForm.patchValue({
    //       [this.controlKey()]: location.siteId
    //     });
    //     this.accessRequiredChange.emit(value.siteName);
    //   }

    // onSelectionChange(value: any): void {
    //     const selectedIds = this.selectedAccessRequired.map(item => item.siteId);
    //     this.parentForm.patchValue({
    //       [this.controlKey()]: selectedIds
    //     });
    //     this.accessRequiredChange.emit(selectedIds.join(', '));
    //   }
    onSelectionChange(value: any): void {
      const selectedIds = this.selectedAccessRequired.map(item => item.siteId);
      this.parentForm.patchValue({
          [this.controlKey()]: selectedIds
      });
      this.accessRequiredChange.emit(selectedIds); // Emit the array of selected IDs
  }

  onSelectAll(items: any): void {
      const selectedIds = items.map((item: ISiteDto) => item.siteId);
      this.parentForm.patchValue({
          [this.controlKey()]: selectedIds
      });
      this.accessRequiredChange.emit(selectedIds); // Emit the array of selected IDs
  }

  onDeSelectAll(items: any): void {
      this.parentForm.patchValue({
          [this.controlKey()]: []
      });
      this.accessRequiredChange.emit([]); // Emit an empty array
  }

  protected initControl(): void {
      let selectedIds: number[] = [];
      if (Array.isArray(this.defaultValue)) {
          selectedIds = this.defaultValue.map(value => Number(value));
      }
      this.selectedAccessRequired = this.availableLocations.filter(item => selectedIds.includes(item.siteId));
      super.initControl();
  }

    // protected initControl(): void {
    //     this.selectedValue = this.availableLocations.find(item => item.siteId === this.defaultValue)?.siteName;
    //     super.initControl();
    // }


  
}
